import * as sagaEffects from 'redux-saga/effects';
import { getFirestore } from 'redux-firestore';
import { getFirebase } from 'react-redux-firebase';

import { getIntl } from '@ackee/jerome/antd';
import message from 'antd/lib/message';

import config from 'config/index';
import * as loglevel from 'config/loglevel';

import types from '../../actionTypes';

import { infoDetailRequestCompleted } from '../../actions';

const { takeEvery, put } = sagaEffects;

function* handler({ meta }) {
    const firestore = getFirestore(getFirebase());
    const intl = yield getIntl();

    try {
        for (const lang of config.app.languages) {
            yield firestore.get({
                collection: `languages/${lang}/infoCategories/${meta.categoryId}/info`,
                doc: `${meta.id}`,
                storeAs: `info<${meta.id},${lang}>`,
            });
        }
    } catch (e) {
        loglevel.error(e);
        message.error(intl.formatMessage({ id: 'errors.info.detail' }));
    } finally {
        yield put(infoDetailRequestCompleted());
    }
}
export default function* () {
    yield takeEvery(types.INFO_DETAIL_REQUEST, handler);
}
